export default function*() {
  yield true
}
